import {createAsyncThunk} from '@reduxjs/toolkit';
import {normalize} from 'normalizr';
import {AppThunkApiConfig} from '../../createStore';
import {buildingEntity} from '../entities';
import {mapiqApi} from '@lib/infrastructure';
import {NormalizedBuildingsResult} from './types';

export const loadBuildings = createAsyncThunk<NormalizedBuildingsResult, void, AppThunkApiConfig>(
  'buildings/loadBuildings',
  async (_, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);

    const buildingsResponse = await api.getBuildings();
    const {entities} = normalize<any, NormalizedBuildingsResult>(buildingsResponse, [buildingEntity]);
    const {buildings, floors, areas} = entities;

    return {
      buildings: buildings ?? {},
      floors: floors ?? {},
      areas: areas ?? {},
      denormalized: buildingsResponse.map((b) => ({
        ...b,
        floors: b.floors.sort((a, b) => a.number - b.number),
      })),
    };
  },
);
